const CLASS_SYNC_GROUP_ATTR = 'data-class-sync-group';
const CLASS_SYNC_LISTENER_ATTR = 'data-class-sync-listener ';
const CLASS_SYNC_ACTIVE_ATTR = 'data-class-sync-active';
const CLASS_SYNC_CLICK_TRIGGER_ATTR = 'data-class-sync-click-trigger';

const CLASS_SYNC_GROUP_SELECTOR = '[' + CLASS_SYNC_GROUP_ATTR + ']';
const CLASS_SYNC_LISTENER_SELECTOR = '[' + CLASS_SYNC_LISTENER_ATTR + ']';
const CLASS_SYNC_CLICK_TRIGGER_SELECTOR = '[' + CLASS_SYNC_CLICK_TRIGGER_ATTR + ']';

const SCAN_INTERVAL_MS = 100;

/**
 * Generic solution that toggles active classes on specific elements depending on if any other element has their classes active.
 * The elements are grouped. 
 */

/*

<!--
    If the below button has the class button-active, then the overlay will automatically get its active class set
-->
<button
    data-class-sync-group="main-menu"         // Group id
    data-class-sync-active="button-active"    // Active class to check for / use
    data-class-sync-click-trigger             // Click trigger attribute
>
    Menu
</button>
[....]
<div 
    class="overlay"
    data-class-sync-group="main-menu"           // Group id
    data-class-sync-active="overlay--active"   // Active class to check for / use
    data-class-sync-listener                    // Listener marker
>
    [..]
</div>
*/


function closest(child, selector) {
    if (!child || !child.matches) {
        return null;
    }

    if (child.matches(selector)) {
        return child;
    }

    return closest(child.parentNode, selector);
}

function hasClass(element, className){
    return element.matches('.' + className)
}
function addClass(element, className){
    return element.classList.add(className);
}
function removeClass(element, className){
    return element.classList.remove(className);
}

export default class ClassSyncer {
    constructor() {
        this.syncTimer;
        this.setupEventListeners();
    }

    setupEventListeners() {
        /*
        // If we need automatic syncing
        this.syncTimer = setInterval(
            () => { this.updateElements(); },
            SCAN_INTERVAL_MS
        )
        */

        document.addEventListener('click', (e) => {
            const clickTarget = e.target;
            let triggerElement = closest(clickTarget, CLASS_SYNC_CLICK_TRIGGER_SELECTOR);

            if (triggerElement) {
                const groupName = triggerElement.getAttribute(CLASS_SYNC_GROUP_ATTR)
                this.updateElements([groupName]);
            }
        });
    }

    getAllGroups() {
        const allSyncElements = [...document.querySelectorAll(CLASS_SYNC_GROUP_SELECTOR)];
        const groups = allSyncElements.map((element) => {
            return element.getAttribute(CLASS_SYNC_GROUP_ATTR);
        }).reduce((uniqueGroups, groupName) => {
            if (uniqueGroups.indexOf(groupName) === -1) {
                uniqueGroups.push(groupName);
            }

            return uniqueGroups;
        }, []);

        return groups;
    }

    updateElements(groupNames = []) {
        let groups = groupNames;

        if (!groups.length) {
            groups = this.getAllGroups();
        }

        groups.forEach((groupName) => {
            this.syncGroup(groupName);
        })
    }

    syncGroup(groupName) {
        const groupSelector = '[' + CLASS_SYNC_GROUP_ATTR + '=' + groupName + ']';
        const groupMemberElements = [...document.querySelectorAll(groupSelector)];
        const groupMemberElementListeners = groupMemberElements.filter((element) => {
            return element.matches(CLASS_SYNC_LISTENER_SELECTOR);
        });
        const groupMemberElementTriggersMarkers = groupMemberElements.filter((element) => {
            return groupMemberElementListeners.indexOf(element) === -1;
        });

        const isActive = groupMemberElementTriggersMarkers.reduce((isActive, currentElement) => {
            if (!isActive) {
                const activeClass = currentElement.getAttribute(CLASS_SYNC_ACTIVE_ATTR);
                isActive = hasClass(currentElement, activeClass);
            }

            return isActive;
        }, false)

        groupMemberElementListeners.forEach((listenerElement) => {
            const activeListenerClass = listenerElement.getAttribute(CLASS_SYNC_ACTIVE_ATTR);
            if (isActive) {
                addClass(listenerElement, activeListenerClass)
            } else {
                removeClass(listenerElement, activeListenerClass)
            }
        });
    }
}